var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10920_35876)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19379 2.03434L1.78565 5.43753H5.43754C5.7482 5.43753 6.00004 5.68937 6.00004 6.00003C6.00004 6.31069 5.7482 6.56253 5.43754 6.56253H1.78565L1.19379 9.9657L10.4471 6.00003L1.19379 2.03434ZM0.741591 6.00003L0.0477866 2.01065C-0.00830184 1.68815 0.0960545 1.35851 0.327526 1.12704C0.618365 0.836206 1.05698 0.751734 1.43503 0.913756L11.4868 5.22165C11.7981 5.3551 12 5.66126 12 6.00003C12 6.33879 11.7981 6.64496 11.4868 6.77841L1.43503 11.0863C1.05698 11.2484 0.618365 11.1638 0.327526 10.8731C0.0960545 10.6415 -0.00830199 10.3119 0.0477866 9.9894L0.741591 6.00003Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10920_35876"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcn);
export default __webpack_public_path__ + "static/media/send-icn.f42f121567aa35dbb6fa2993ab7221ec.svg";
export { ForwardRef as ReactComponent };